import * as THREE from 'three';
import { ClosePath } from '../objects/ClosePath';


export class NearPointDelete {

    private epsilon: number = 500;

    // 近くの点のポイントのインデックスを探索
    public check(shape: ClosePath): number[] {

        const numberOfPoints = shape.position.length;

        const result: number[] = [];

        // shapeを構築する点間の近傍点を削除対象とする
        for (let i = 0; i < numberOfPoints; i += 1) {
            const p1 = shape.position[i];
            const p2 = shape.position[(i + 1) % numberOfPoints];

            // 二点間の距離を測り、epsilon(誤差)以内なら削除対象.
            if (p1.distanceTo(p2) < this.epsilon)
                result.push(i);
        }
        return result;
    }

    public check_1(shape: ClosePath): number[] {
        const result = shape.position.map((p: THREE.Vector2, index: number) => {
            return p.distanceTo(shape.position[(index + 1) % shape.position.length]) < this.epsilon;
        });
        return [...Array(shape.position.length).keys()].filter((v: number, index: number) => result[index]);
    }

    public check_2(shape: ClosePath): number[] {
        return shape.position.map((p: THREE.Vector2, index: number) => {
            return p.distanceTo(shape.position[(index + 1) % shape.position.length]) < this.epsilon ? index : -1;
        })
        .filter((value: Number) => value >= 0);
    }

    public check_3(shape: ClosePath): number[] {
        return shape.position.map((p: THREE.Vector2, index: number) => {
            return p.distanceTo(shape.position[(index + 1) % shape.position.length]) < this.epsilon;
        }).reduce((acc, value, index) => {
            if (value) acc.push(index);
            return acc;
        }, []);
    }

    public check_4(shape: ClosePath): number[] {
        return shape.position.reduce((acc, p, index) => {
            if (p.distanceTo(shape.position[(index + 1) % shape.position.length]) < this.epsilon) {
                acc.push(index);
            }
            return acc;
        }, []);
    }

    // 誤差を設定する
    public setDistance(distance: number) {
        this.epsilon = distance;
    }

}
